import { Component, OnInit } from '@angular/core';
import 'rxjs';
declare var $:any;

@Component({
  selector: 'app-product-landing',
  templateUrl: './title-toolbox.component.html',
  styleUrls: ['./title-toolbox.component.scss']
})
export class TitleToolboxComponent implements OnInit {
  title = 'TitleToolBox';

  public screenShots = [
    {img:'/assets/images/ttb-1.jpg'},
    {img:'/assets/images/ttb-2.jpg'},
    {img:'/assets/images/ttb-3.jpg'},
    {img:'/assets/images/ttb-4.jpg'}
  ];

  ngAfterViewInit(){
    $('.center').slick({
      centerMode: true,
      dots: false,
      slidesToShow: 3,
      variableWidth: true,
      centerPadding: '35px 35px 35px',
    });
  }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/pages/products/title-toolbox/title-toolbox.component.ts